import { render, staticRenderFns } from "./HomepageUserHeaderBox.vue?vue&type=template&id=ac08b3e0&scoped=true&"
import script from "./HomepageUserHeaderBox.vue?vue&type=script&lang=ts&"
export * from "./HomepageUserHeaderBox.vue?vue&type=script&lang=ts&"
import style0 from "./HomepageUserHeaderBox.vue?vue&type=style&index=0&id=ac08b3e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac08b3e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileAvatar: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/profile/ProfileAvatar.vue').default})
